module.exports = __webpack_public_path__ + "static/media/素麻辣紫米臭豆腐.8e0957f7.jpg";